const API = {
  async getAsync(url, data = null, options = {}) {
    return await this.fetchAsync("GET", url, data, options.headers, options.errorHandler, options.signal);
  },

  async putAsync(url, data, config) {
    return await this.fetchAsync("PUT", url, data, config);
  },

  async putFormAsync(url, data) {
    return await this.fetchAsync("PUT", url, data, { "Content-Type": "form-data" });
  },

  async patchAsync(url, data) {
    return await this.fetchAsync("PATCH", url, data);
  },

  async postAsync(url, data, options = {}) {
    return await this.fetchAsync("POST", url, data, options.headers, options.errorHandler, options.signal);
  },

  async sendAsync(url, data) {
    if (!data.id || data.id === 0) return await this.fetchAsync("POST", url, data);
    else return await this.fetchAsync("PUT", url, data);
  },

  async postFileAsync(url, file) {
    var formData = new FormData();
    formData.append("file", file);
    if (file.name) formData.append("fileName", file.name);
    // debugger;
    return await this.fetchAsync("POST", url, formData);
  },

  async versionAsync() {
    let url = this.URL("/version");
    const resp = await this.fetchAsync("GET", url, null, {
      "Content-Type": "text/plain",
    });
    if (resp && resp.ok) {
      return resp.jsonData.version;
    }
  },

  concatenateUrlParts(...parts) {
    var ret = parts
      .map(part => part.replace(/^\/|\/$/g, '')) 
      .filter(part => part) 
      .join('/');
    return ret;
  },

  URL(baseUrl, path, paramsObj) {
    let ApiUrl = import.meta.env.VITE_API_URL;

    let uri = "";
    //console.log(import.meta.env);
    if (baseUrl) {
      if (!baseUrl.startsWith("http://") && !baseUrl.startsWith("https://")) {
        if (!ApiUrl) {
          throw new Error("VITE_API_URL is not set. Check the Vite mode .env file for this build.");
        }
        uri = ApiUrl.replace(/\/+$/, "");
        uri += "/" + baseUrl.replace(/^\/+|\/+$/g, "");
      } else uri = baseUrl;
    }
    if (path && path.length > 0) uri = uri + "/" + path.replace(/^\/+|\/+$/g, "");
    if (paramsObj) {
      const queryString = Object.keys(this.paramsObj)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(this.params[key])}`)
        .join("&");
      if (queryString && queryString.length > 0) uri = uri + `?${queryString}`;
    }
    return uri;
  },
  async deleteAsync(url, data, config) {
    return await this.fetchAsync("DELETE", url, data, config);
  },

  async logError(error) {
    const data = { message: btoa(error.toString()) };
    await this.fetchAsync("POST", "/UIError", data);
  },

  async fetchAsync(verb, url, data, additionalHeaders, errorHandler, signal) {
    try {
      const headers = {};
      // Add a custom header to identify API calls in the network tab
      headers["X-Request-Type"] = "API-Call";
      
      const token = window.sessionStorage.getItem("BearerToken");
      if (token && token.length > 20) headers["Authorization"] = "Bearer " + token;
      else window.sessionStorage.removeItem("BearerToken");
      const origin = window.location.href;
      if (origin) headers["Referer"] = origin;
      if (additionalHeaders) {
        Object.entries(additionalHeaders).forEach(([key, value]) => {
          headers[key] = value;
        });
      }
      let init = {
        method: verb,
        headers: headers,
        signal: signal,
      };
      if (data) {
        if (data instanceof FormData) {
          init.body = data;
          // Do not set Content-Type header manually for FormData
        } else {
          init.body = JSON.stringify(data);
          init.headers["Content-Type"] = "application/json";
        }
      } url = this.URL(url);
      console.log(["fetch", verb, url, init]);
      let response;
      try {
        response = await fetch(url, init);
      } catch (fetchError) {
        console.error("Fetch error:", fetchError);
        // Return early with a proper error response when fetch fails
        return {
          ok: false,
          status: 0,
          statusText: fetchError.message,
          error: fetchError,
          jsonData: null
        };
      }

      // Only access headers if response exists
      const contentType = response.headers ? response.headers.get("Content-Type") : null;

      if (contentType && contentType.includes("application/json")) {
        try {
          console.error("Parsing JSON response from", url);
          response.jsonData = await response.json();
        } catch (jsonError) {
          console.error("Error parsing JSON response:", jsonError);
          response.jsonData = null; // Set to null if JSON parsing fails
        }
      }

      if (!response.ok) {
        if (errorHandler) {
          errorHandler(response);
        } else {
          if (!url.includes("UIError"))
            this.logError(
              "Error calling [" + verb + "] " + url + " StatusCode:" + response.status + " " + response.statusText
            );
          console.log(["Error calling", verb, url, "StatusCode:" + response.status, response.statusText]);
        }
      }
      return response;
    } catch (error) {
      console.log("🔴 CATCH BLOCK HIT - ERROR:", error);
      debugger;
      // Temporarily disable logError to avoid cascade failures
      // if (!url.includes("UIError"))
      //   this.logError("Exception calling [" + verb + "] " + url + " " + error);
      console.log("Exception calling", verb, url, error);

      return {
        ok: false,
        status: 0,
        statusText: error.message,
        error: error,
        jsonData: null
      };
    }
  }
};

export default API;
